import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CellHeaderStyled = styled(TableCell)(({ theme }) => ({
  fontSize: '12px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  fontWeight: theme.typography.subtitle1.fontWeight,
  '&:first-child': {
    width: 30,
  },
  '& + th:nth-child(3)': {
    width: 350,
  },
  '&:last-child': {
    width: 150,
  },
}));

export const CellBodyStyled = styled(TableCell)(() => ({
  alignItems: 'center',
  '& + td:nth-child(3)': {
    '& svg': {
      display: 'none',
    },
  },
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const ButtonsActionsStyled = styled(TableCell)(({ theme }) => ({
  minHeight: 52,
  display: 'flex',
  '& .buttonEdit': {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  '& .buttonDelete': {
    '&:hover': {
      color: '#ff0000',
    },
  },
}));
